var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"ps-inline-flex ps-items-center"},[_c('span',[_vm._t("default")],2),_c('span',{staticClass:"ps-inlie-flex ps-items-center ps-ml-2 ps-svg-down"},[_c('svg-icon',{attrs:{"name":"go","width":"16","height":"auto"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }